import React from 'react';

function Credits() {
    return (
        <section id="credits">
            <div className="container">
                <div className="copyright">
                    &copy; Copyright <strong>NEEQ-FEUP</strong>
                </div>
            </div>
        </section>
    );
}

export default Credits;